import { notification } from "antd";
import { ReactNode } from "react";

export interface INotificationService {
  showError(messageText: string): void;
  showSuccess(messageText: string): void;
  showInfo(messageText: string): void;
  showWarning(messageText: string): void;
  showInfoNotificationBox(message: string, description: string): void;
  showErrorWithButton(messageText: string, button: any);
}

const DURATION_MESSAGE_SECONDS = 2.5;
const DURATION_NOTIFICATION_BOX_SECONDS = 8;

const NotificationService = ({ translationService }): INotificationService => {
  const formatMessageText = (messageText: string) => {
    const splitMessage = messageText?.split("-");
    if (splitMessage?.length === 2) {
      return splitMessage[1];
    } else return messageText;
  };

  const showMessage = (
    messageText: string,
    type: "success" | "info" | "warning" | "error",
    button?: ReactNode
  ) => {
    const method = notification[type];

    method({
      message: translationService.get(`app.${type}`),
      description: formatMessageText(messageText),
      duration: DURATION_MESSAGE_SECONDS,
      btn: button
    });
  };

  return {
    showError(messageText: string) {
      showMessage(messageText, "error");
    },
    showErrorWithButton(messageText: string, button: ReactNode) {
      showMessage(messageText, "error", button);
    },

    showSuccess(messageText: string) {
      showMessage(messageText, "success");
    },

    showInfo(messageText: string) {
      showMessage(messageText, "info");
    },

    showWarning(messageText: string) {
      showMessage(messageText, "warning");
    },

    showInfoNotificationBox(message: string, description: string) {
      notification.info({
        message,
        description,
        duration: DURATION_NOTIFICATION_BOX_SECONDS
      });
    }
  };
};

export default NotificationService;
